// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import { useLazyQuery, useMutation } from "@apollo/client";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  mergeAllDataIntoFormData,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import {
  CREATE_BOOKING_BROKER,
  DELETE_Voucher_MUTATION,
  EDIT_BOOKING_BROKER,
  GET_BOOKING_BROKER_BY_ID,
  getFormSectionsAndFields,
  UserDataById,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { useDispatch } from "react-redux";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { useModalContext } from "../../Reactportal/ModalContext";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  BillPartyFreightCharges,
  BookingBrokerConfig,
  docs,
  TransporterFreightCharges,
  VehicleMaterialDetailsConfig,
} from "./AddBookingBrokerConfig";
import { useSelector } from "react-redux";
import { useEventListener } from "usehooks-ts";
import "./AddBookingBroker.scss";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import LRPickupUpdationFreightChargesForm from "../LRPickupUpdation/LRPickupUpdationSections/LRPickupUpdationFreightChargesForm";
import { AddVoucher } from "../../AddVoucher/AddVoucher";
import Button from "../../Button/Button";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { handleFormReset, updateSingleField, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { LoadTable } from "../..";
import TransacionBrokerTable from "./TransactionBrokerTable";
import { Confirm } from "../../Confirmation/Confirm";
import MarkDelivery from "./MarkDelivery";
import { Addition } from "../../../../CommonFunction/CalculationsWithDecimalValues";

function convertTo12HourFormat(timeString) {
  // Parse the input time string to extract hours and minutes
  const date = new Date("1970-01-01T" + timeString?.split(" ")[0] + "Z");

  let hours = date.getUTCHours(); // Extract hours
  let minutes = date.getUTCMinutes(); // Extract minutes
  const ampm = hours >= 12 ? "PM" : "AM"; // Determine AM or PM

  hours = hours % 12 || 12; // Convert to 12-hour format (0 becomes 12)
  minutes = minutes.toString().padStart(2, "0"); // Ensure 2-digit minutes

  return `${hours}:${minutes} ${ampm}`;
}

const AddBookingBroker = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  // GET_BOOKING_BROKER_BY_ID
  const [toggle, settoggle] = useState(show ? show : false);
  const Form_Key = "Booking_Broker";
  const [field, setFields] = useState(BookingBrokerConfig);
  const [formErrors, setFormErrors] = useState({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  // const [alldata, setalldata] = useState({});
  const [paymentUserData, setPaymentUserData] = useState();
  const [receiptUserData, setReceiptUserData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [DeliveryData, setDeliveryData] = useState([]);
  const [customerNotesdata, setCustomerNotesdata] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [MarkDeliveryModal, setMarkDeliveryModal] = useState(false);
  const [PaymentBalanceAmount, setPaymentBalanceAmount] = useState(0);
  const [ReceiptBalanceAmount, setReceiptBalanceAmount] = useState(0);
  const [VoucherModal, setVoucherModal] = useState(false);
  const [DeleteVoucherId, setDeleteVoucherId] = useState("");
  const [totalFreightAmount, setTotalFreightAmount] = useState(0);
  const [totalFreightAmount1, setTotalFreightAmount1] = useState(0);
  //new
  let userData = sessionStorage.getItem("userData") && JSON.parse(sessionStorage?.getItem("userData") || "");
  const dispatch = useDispatch();
  const formRef = useRef({});
  //new
  const [InputFields, setInputFields] = useState([]);
  const [FormData, setFormdata] = useState({});
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const { paymentData, receiptData } = useSelector((store: any) => store?.BookingBrokerVoucherData);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux[Form_Key]?.Selected_Row;
  const [CreatingData, { loading: createBookingBrokerLoading }] = useMutation(CREATE_BOOKING_BROKER);
  const [EditingData, { loading: editBookingBrokerLoading }] = useMutation(EDIT_BOOKING_BROKER);
  const [getDataById, { loading: getDataByIdLoader }] = useLazyQuery(GET_BOOKING_BROKER_BY_ID, {
    fetchPolicy: "network-only",
  });
  const [deleteJournalVoucher, { loading: deleteJournalVoucherLoading }] = useMutation(DELETE_Voucher_MUTATION);
  const [allFieldsData, setAllFieldsData] = useState({});
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "network-only",
      onCompleted: (data) => {

        setInputFields(data?.formSectionAndFields);
      },
    }
  );

  const [getUserDataById, { loading: GetUserDataLoading }] = useLazyQuery(UserDataById, {
    fetchPolicy: "no-cache",
  });
  const BookingBrokerLoadingState = createBookingBrokerLoading || getDataByIdLoader || editBookingBrokerLoading;
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let formData: any = FormData;
  const variables = usePrepareGraphQLVariables(operationType, fielddata, formData, selectedRows);
  const MutationFunctions = {
    CreatingData,
    EditingData,
    // MergingData,
  };

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    if (userData.userDetails[0]._id && TypeOfPortal?.includes("Add")) {
      getUserDataById({
        variables: {
          ID: userData?.userDetails[0]?._id,
        },
      }).then((res) => {
        if (res?.data?.user[0]?.LR_Center_Data?.Center_Name) {
          // setLRCenterDisabled(true);
        }
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Center_Id: res?.data?.user[0]?.LR_Center_Data,
            },
          },
        });

        updateSingleField(formRef, "Center_Id", res?.data?.user?.[0]?.LR_Center_Data?.Center_Name || "");
        updateSingleField(formRef, "Booking_No", res?.data?.user?.[0]?.LR_Center_Data?.lr_books?.Current_Number || "");
      });
    }
  }, [userData?.userDetails[0]?._id]);

  useEffect(() => {
    if (TypeOfPortal === "Add" && FormDataFromRedux?.MasterData[Form_Key]?.Center_Id) {
      updateSingleField(
        formRef,
        "Booking_No",
        FormDataFromRedux?.MasterData[Form_Key]?.Center_Id?.lr_books?.Current_Number || ""
      );
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Center_Id]);

  useEffect(() => {
    let totalAmount = 0;

    if (paymentData.length > 0) {
      let NewData = paymentData.map((e, i) => {
        totalAmount = Addition(totalAmount, e.TransactionsData[i]?.Amount);
        return {
          _id: e._id,
          Narration: e.Narration,
          Entry_Type: e.Entry_Type,
          Date: IsoToDateWithoutTime(e.Date),
          Transporter_Account: e.TransactionsData[0]?.Account?.Account_Name,
          Credit_Account: e.TransactionsData[1]?.Account?.Account_Name,
          Debit_Amount: e.TransactionsData[0]?.Amount,
        };
      });

      setPaymentUserData(NewData);
    } else {
      setPaymentUserData([]);
    }
    if (FormData.Transporter_Freight_Amount) {
      totalAmount = FormData.Transporter_Freight_Amount - totalAmount;
      setPaymentBalanceAmount(totalAmount);
    } else {
      setPaymentBalanceAmount(0);
    }
  }, [paymentData, FormData.Transporter_Freight_Amount]);

  useEffect(() => {
    if (
      TypeOfPortal === "Add" &&
      (FormDataFromRedux?.MasterData[Form_Key]?.Vehicle_No || FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name)
    ) {
      let VehicleData = FormDataFromRedux?.MasterData[Form_Key]?.Vehicle_No;
      let DriverData = FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name;
      if (DriverData?.Mobile_Number) {
        updateSingleField(formRef, "Driver_Number", DriverData?.Mobile_Number);
      } else {
        updateSingleField(formRef, "Driver_Number", "");
      }

      if (VehicleData?.Vehicle_Type) {
        updateSingleField(formRef, "Vehicle_Type", VehicleData?.Vehicle_Type);
      } else {
        updateSingleField(formRef, "Vehicle_Type", "");
      }
      if (VehicleData?.Load_Capacity) {
        updateSingleField(formRef, "Load_Capacity", Number(VehicleData?.Load_Capacity));
      } else {
        updateSingleField(formRef, "Load_Capacity", "");
      }
    }
  }, [FormDataFromRedux.MasterData[Form_Key]?.Driver_Name, FormDataFromRedux?.MasterData[Form_Key]?.Vehicle_No]);

  useEffect(() => {
    let totalAmount = 0;
    if (receiptData.length > 0) {
      let NewData = receiptData.map((e, i) => {
        totalAmount = Addition(totalAmount, e.TransactionsData[i]?.Amount)
        return {
          _id: e._id,
          Narration: e.Narration,
          Entry_Type: e.Entry_Type,
          Date: IsoToDateWithoutTime(e.Date),
          Transporter_Account: e.TransactionsData[0]?.Account?.Account_Name,
          Credit_Account: e.TransactionsData[1]?.Account?.Account_Name,
          Debit_Amount: e.TransactionsData[0]?.Amount,
        };
      });

      setReceiptUserData(NewData);
    } else {
      setReceiptUserData([]);
    }

    if (FormData.Bill_Party_Freight_Amount) {
      totalAmount = FormData.Bill_Party_Freight_Amount - totalAmount;
      setReceiptBalanceAmount(totalAmount);
    } else {
      setReceiptBalanceAmount(0);
    }
  }, [receiptData, FormData.Bill_Party_Freight_Amount]);

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal !== "Add" && TypeOfPortal !== "Delete") {
        getDataById({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let BookingData = { ...data?.GetBookingBrokerByID };
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Bill_Consignor: BookingData?.Bill_Consignor_Data,
                Transporter_Account: BookingData?.Transporter_Account_Data,
                Bill_Consignor_Person: BookingData?.Bill_Consignor_Person_Data,
                Transporter_Contact_Person: BookingData?.Transporter_Contact_Person_Data,
                From: BookingData?.From_Data,
                To: BookingData?.To_Data,
                Vehicle_No: BookingData?.Vehicle_No_Data,
                Driver_Name: BookingData?.Driver_Name_Data,
                Branch_Code: BookingData?.Branch_Code_Data,
                Center_Id: BookingData?.Center_Id_Data,
              },
            },
          });

          BookingData.Bill_Consignor = BookingData?.Bill_Consignor_Data?.Search_Value;
          BookingData.Transporter_Account = BookingData?.Transporter_Account_Data?.Search_Value;
          BookingData.Bill_Consignor_Person = BookingData?.Bill_Consignor_Person_Data?.Name;
          BookingData.Transporter_Contact_Person = BookingData?.Transporter_Contact_Person_Data?.Name;
          BookingData.Vehicle_No = BookingData?.Vehicle_No_Data?.Vehicle_No;
          BookingData.From = BookingData?.From_Data?.name;
          BookingData.To = BookingData?.To_Data?.name;
          BookingData.Driver_Name = BookingData?.Driver_Name_Data?.Name;
          BookingData.Center_Id = BookingData?.Center_Id_Data?.Search_Value;
          BookingData.Date = IsoToDateWithoutTime(BookingData?.Date);

          setCustomerNotesdata(BookingData?.Note);
          if (BookingData?.Is_Delivery_Marked) {
            setDeliveryData([
              {
                Delivery_Date: BookingData.Delivery_Date,
                Delivery_Time: BookingData.Delivery_Time ? convertTo12HourFormat(BookingData.Delivery_Time) : "",
                Delivery_Remark: BookingData.Delivery_Remark,
              },
            ]);
          } else {
            BookingData.Delivery_Date = GetTodaysDateINdmy();
            setDeliveryData([
              {
                Delivery_Date: GetTodaysDateINdmy(),
                Delivery_Time: "",
                Delivery_Remark: "",
              },
            ]);
          }

          dispatch({ type: "SET_ALL_PAYMENT_DETAILS", payload: BookingData?.Payments_Voucher_Data });
          dispatch({ type: "SET_ALL_RECEIPT_DETAILS", payload: BookingData?.Receipt_Voucher_Data });

          updateValueForm(formRef, BookingData);
        });
      } else {
        // setAllFieldsData({ Date: GetTodaysDateINdmy() });
        updateValueForm(formRef, {
          Date: GetTodaysDateINdmy(),
          Delivery_Date: GetTodaysDateINdmy(),
        });
      }
    }
  }, [fielddata, InputFields]);

  useEffect(() => {
    const input = document.getElementsByName("Date");
    if (input.length > 0 && !TypeOfPortal?.includes("View")) {
      input[input.length - 1].focus();
    }
  }, []);

  const handleToggleFun = (type) => {
    dispatch({ type: "SET_CURRENT_KEY", payload: type });
    setVoucherModal(true);
  };

  let handleMarkDeliverySubmit = () => {
    setDeliveryData([
      {
        Delivery_Date: FormData.Delivery_Date,
        Delivery_Time: convertTo12HourFormat(FormData.Delivery_Time),
        Delivery_Remark: FormData.Delivery_Remark,
      },
    ]);
  };

  let openDeleteModalFun = (id) => {
    setDeleteVoucherId(id);
    setOpenDeleteModal(true);
  };

  let handleVoucherDeleteFun = () => {

    dispatch({ type: "DELETE_BY_ID", payload: DeleteVoucherId });
    setDeleteVoucherId("");
    setOpenDeleteModal(false);
    // deleteJournalVoucher({
    //   variables: { idsToDelete: id },
    // })
    //   .then((res) => {
    //     SuccessToast("Voucher Deleted");
    //     // dispatch({ type: "Refetch", payload: true });
    //     // Closeformfunction();
    //   })
    //   .catch((err) => {
    //     ErrorToast(err.message);
    //   });
  };

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleKeyDown = (event) => {
    if (getTopModal() === Form_Key) {
      if (event.key === "Escape") {
        Closeformfunction();
      } else if (event.key === "F4" && !TypeOfPortal?.includes("View")) {
        Validate_handleSubmit(SaveAndCloseForAdd);
      }
    }
  };

  useEventListener("keydown", handleKeyDown);

  useEffect(() => {
    setSelectedRows(fielddataRedux[Form_Key]?.Selected_Rows);
  }, [fielddataRedux]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const Closeformfunction = () => {
    ClearSpecificForm(dispatch, Form_Key);
    popModal(Form_Key);
    // handleFormReset(formRef);
    setCustomerNotesdata("");
    setReceiptUserData([]);
    setPaymentUserData([]);
    setReceiptBalanceAmount(0);
    setPaymentBalanceAmount(0);
    setDeliveryData([]);
    dispatch({ type: "CLEAR_VOUCHER_DETAILS" });
    settoggle(false);
    ParentPortalCloseFunction();
  };

  const submit = async (closeAction) => {
    let paymentId = paymentData?.map((e) => e?._id);
    let receiptId = receiptData?.map((e) => e?._id);
    formData.From = FormDataFromRedux.MasterData[Form_Key].From?._id;
    formData.To = FormDataFromRedux.MasterData[Form_Key].To?._id;
    formData.Bill_Consignor = FormDataFromRedux.MasterData[Form_Key].Bill_Consignor?._id;
    formData.Transporter_Account = FormDataFromRedux.MasterData[Form_Key].Transporter_Account?._id;
    formData.Bill_Consignor_Person = FormDataFromRedux.MasterData[Form_Key].Bill_Consignor_Person?._id;
    formData.Transporter_Contact_Person = FormDataFromRedux.MasterData[Form_Key].Transporter_Contact_Person?._id;
    formData.Vehicle_No = FormDataFromRedux.MasterData[Form_Key].Vehicle_No?._id;
    formData.Center_Id = FormDataFromRedux.MasterData[Form_Key].Center_Id?._id;
    formData.Driver_Name = FormDataFromRedux.MasterData[Form_Key].Driver_Name?._id;
    formData.Book_Id = FormDataFromRedux?.MasterData[Form_Key]?.Center_Id?.lr_books?._id;
    formData.Vehicle_Type = formData.Vehicle_Type ? String(formData.Vehicle_Type) : "";
    formData.Eway_Bill_Number = formData.Eway_Bill_Number ? String(formData.Eway_Bill_Number) : "";
    formData.Driver_Number = formData.Driver_Number ? String(formData.Driver_Number) : "";
    formData.Note = customerNotesdata;
    formData.Date = formData.Date ? convertToISO(formData.Date) : "";
    formData.Payments_Voucher_IDs = paymentId;
    formData.Receipt_Voucher_IDs = receiptId;
    if (DeliveryData?.length > 0) {
      formData.Is_Delivery_Marked = true;
    }

    const mutationFunction = getMutationFunction(operationType, MutationFunctions);
    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        PageName: Form_Key,
        OnSuccess: (res) => { },
      });
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        setCustomerNotesdata("");
        setReceiptUserData([]);
        setPaymentUserData([]);
        setReceiptBalanceAmount(0);
        setPaymentBalanceAmount(0);
        setDeliveryData([]);
        dispatch({ type: "CLEAR_VOUCHER_DETAILS" });
        handleFormReset(formRef);
      },
      onSuccess: () => { },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add" ? () => Validate_handleSubmit(SaveAndCloseForAdd) : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={BookingBrokerLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          ShowBranchInput={true}
          Form_Key={Form_Key}
          TypeOfPortal={TypeOfPortal + " Booking (Broker)"}
        >
          <div className="BookingBrokerMaindiv">
            {BookingBrokerLoadingState && <div className="loader-line-div" />}
            <div className="formcontainer">
              {InputFields &&
                InputFields.map((e) => {
                  return (
                    <div key={e.id} className="">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="formSection insidecontainer">
                        <FormInputSectionComponent
                          inputfields={e.fields}
                          Type={e.name}
                          fielddata={allFieldsData}
                          onhandleFormikChange={HanldeChangeonForm}
                          // validation_Schema={e?.Valid_schema}
                          onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                          formkey={Form_Key}
                          formRef={formRef}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
            {/* <div className="formcontainer">
              {VehicleMaterialDetailsConfig &&
                VehicleMaterialDetailsConfig.map((e) => {
                  return (
                    <div key={e.id} className="">
                      <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                      <div className="formSection insidecontainer">
                        <FormInputSectionComponent
                          inputfields={e.fields}
                          Type={e.name}
                          onErrorsChange={handleErrorsChange}
                          TypeOfPortal={TypeOfPortal}
                          formkey={Form_Key}
                          formRef={formRef}
                          onhandleFormikChange={HanldeChangeonForm}
                        />
                      </div>
                    </div>
                  );
                })}
            </div> */}
            <div className="BookingFooterMaindiv">
              <div>
                <div>
                  <p className="BookingFooterLabel">Note</p>
                </div>
                <div className="customerNote">
                  <textarea
                    name="note"
                    className="Note"
                    value={customerNotesdata}
                    onChange={(e) => setCustomerNotesdata(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div>
                <div>
                  <p className="BookingFooterLabel">Documents</p>
                </div>
                <div className="loadImages1">
                  <DocumentuploadSection
                    data={docs}
                    TypeOfPortal={TypeOfPortal}
                    LoadForm={true}
                    formkey={Form_Key}
                    values={FormData}
                    formReference={formRef}
                  />
                </div>
              </div>
              <div>
                <div>
                  <p className="BookingFooterLabel">Transporter Fright Charges</p>
                </div>
                <div className="Freight">
                  {TransporterFreightCharges.map((e: any, i) => {

                    return (
                      <LRPickupUpdationFreightChargesForm
                        inputfields={e.fields}
                        Type={e.name}
                        handleFreightOnChange={() => { }}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        FormData={FormData}
                        formRef={formRef}
                        TotalKeyName={"Transporter_Sub_Total"}
                        onhandleFormikChange={HanldeChangeonForm}
                      />
                    );
                  })}
                </div>
              </div>
              <div>
                <div>
                  <p className="BookingFooterLabel">Bill Party Fright Charges</p>
                </div>
                <div className="Freight">
                  {BillPartyFreightCharges.map((e: any, i) => {
                    return (
                      <LRPickupUpdationFreightChargesForm
                        inputfields={e.fields}
                        Type={e.name}
                        handleFreightOnChange={() => { }}
                        TypeOfPortal={TypeOfPortal}
                        formkey={Form_Key}
                        FormData={FormData}
                        formRef={formRef}
                        TotalKeyName={"Bill_Party_Sub_Total"}
                        onhandleFormikChange={HanldeChangeonForm}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="TransactionTables">
              <div className="paymentDetails">
                <TransacionBrokerTable
                  UserTransactionData={paymentUserData}
                  tableFor={"Payment"}
                  heading={"Transporter Transaction Details"}
                  Amount={PaymentBalanceAmount}
                  handleDeleteModal={openDeleteModalFun}
                  handleToggleFun={handleToggleFun}
                />
              </div>
              <div className="paymentDetails">
                <TransacionBrokerTable
                  UserTransactionData={receiptUserData}
                  tableFor={"Receipt"}
                  heading={"Bill Party Transaction Details"}
                  Amount={ReceiptBalanceAmount}
                  handleDeleteModal={openDeleteModalFun}
                  handleToggleFun={handleToggleFun}
                />
              </div>
            </div>
            <div className="DeliveryTables">
              {DeliveryData?.length > 0 && (
                <div className="paymentDetails">
                  <TransacionBrokerTable
                    UserTransactionData={DeliveryData}
                    tableFor={"Delivery"}
                    heading={"Mark Delivery"}
                    Amount={""}
                    handleDeleteModal={() => { }}
                    handleToggleFun={() => { }}
                  />
                </div>
              )}

              <div>
                <Button
                  action={() => setMarkDeliveryModal(true)}
                  text={DeliveryData?.length > 0 ? "Edit Remark" : `Mark Delivery`}
                  name="paymentsBtn"
                  type={""}
                  children={""}
                  disabled={""}
                />
              </div>
            </div>
          </div>
        </Reactportal>
      </div>
      <AddVoucher
        show={VoucherModal}
        onClose={() => setVoucherModal(false)}
        ParentPortalCloseFunction={() => setVoucherModal(false)}
      />
      {openDeleteModal ? (
        <Confirm
          toggle={openDeleteModal}
          settoggle={() => {
            setOpenDeleteModal(false);
            setDeleteVoucherId("");
          }}
          submit={handleVoucherDeleteFun}
          loadingState={deleteJournalVoucherLoading}
        />
      ) : (
        ""
      )}
      {MarkDeliveryModal && (
        <MarkDelivery
          show={MarkDeliveryModal}
          Form_Key={Form_Key}
          formRef={formRef}
          handleSubmit={handleMarkDeliverySubmit}
          handleErrorsChange={handleErrorsChange}
          HanldeChangeonForm={HanldeChangeonForm}
          handleClose={() => setMarkDeliveryModal(false)}
          TypeOfPortal={TypeOfPortal}
          FormData={FormData}
        />
      )}
    </>
  );
};

export default AddBookingBroker;
